import React, { useEffect, useState, useContext, useRef } from "react";
import "../../css/Stylesheet-T.css";
import Loader from "../Props/Loader";
import MyContext from "../MyContext";
import AlertBox from "../Props/AlertBox";
import AlertBoxError from "../Props/AlertBoxError";
import MainButton from "./../Props/MainButton";
import LensCreationTable from "./LensCreationTable";
import ItemMasterAPI from "../../API/APIServices/ItemMaster";
import ItemGroupAPI from "../../API/APIServices/ItemGroup";
import LensPowerMasterApi from "../../API/APIServices/LensItemCreation";
import { useNavigate } from "react-router-dom";
import LensItemCreation from "../../API/APIServices/LensItemCreation";
import ItemMaster from "../Master/InvertoryMaster/ItemMaster";
import Account from "../../API/APIServices/Account";

// eslint-disable-next-line import/no-webpack-loader-syntax
import LensStockWorker from "worker-loader!../../Workers/LensStockWorker";
import Swal from "sweetalert2";

const LensStock = () => {
  const {
    OpenAlertBox,
    alertBox,
    OpenAlertBoxEdit,
    alertBoxEdit,
    alertBoxErrorUpdate,
    alertBoxErrorInsert,
    OpenAlertBoxErrorInsert,
    OpenAlertBoxErrorUpdate,
  } = useContext(MyContext);

  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Lens Stock";
  }, []);

  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(1000);
  const [totalRecords, setTotalRecords] = useState(0);

  const [isHovered3, setIsHovered3] = useState(false);
  const [combinedV, setcombined] = useState([]);

  const [highlightedIndex, setHighlightedIndex] = useState(-1);

  const [fetchLensPowerData, setfetchLensPowerData] = useState([]);

  const [sphValue, setSphValues] = useState([]);
  const [cylValue, setCylValues] = useState([]);
  const [axisValue, setAxisValues] = useState([]);
  const [addValue, setAddValues] = useState([]);

  const [lensStockReport, setLensStockReport] = useState([]);
  const [lensStockReportCol, setLensStockReportCol] = useState([]);
  const [lensStockReportColWiseTotal, setLensStockReportColWiseTotal] =
    useState({});
  const [numberOfFirstNotAddColumns, setNumberOfFirstNotAddColumns] =
    useState(0);
  const [wholeTotal, setWholeTotal] = useState(0);

  const [inputValues, setInputValues] = useState({
    ParentGrp: "",
    ItemName: "",
    ItemId: "",
    SPH_Min: "",
    SPH_Max: "",
    SPH_Step: "",
    CYL_Min: "",
    CYL_Max: "",
    CYL_Step: "",
    Add_Min: "",
    Add_Max: "",
    Add_Step: "",
    Eye: "",
    Axis: "",
  });

  const [isAdditionPresent, setIsAdditionPresent] = useState(true);
  const [columns1IfAdditionNotPresent, setColumns1IfAdditionNotPresent] = useState([]);
  const [columns2IfAdditionNotPresent, setColumns2IfAdditionNotPresent] = useState([]);
  const [rowsIfAdditionNotPresent, setRowsIfAdditionNotPresent] = useState({});
  const [totalIfAdditionNotPresent, setTotalIfAdditionNotPresent] = useState({});
  const [listOfSPHInVerticalColumnIfAdditionNotPresent, setListOfSPHInVerticalColumnIfAdditionNotPresent] = useState({});

  const [worker, setWorker] = useState(null);

  console.log("lensStockReportCol", lensStockReportCol);

  useEffect(() => {
    // Create worker
    // const newWorker = new Worker(new URL('../../Workers/LensStockWorker', import.meta.url));
    const newWorker = new LensStockWorker();

    setWorker(newWorker);

    newWorker.onmessage = (e) => {
      console.log("Main thread received:", e.data);
      ;

      setLensStockReport(e.data.rows);
      setLensStockReportCol(e.data.columns);
      setNumberOfFirstNotAddColumns(e.data.numberOfFirstNotAddColumns);
      setLensStockReportColWiseTotal(e.data.columnWiseTotal);
      setWholeTotal(e.data.total);

      setIsAdditionPresent(e.data.isAdditionPresent);
      setColumns1IfAdditionNotPresent(e.data.columns1IfAdditionNotPresent);
      setColumns2IfAdditionNotPresent(e.data.columns2IfAdditionNotPresent);
      setRowsIfAdditionNotPresent(e.data.rowsIfAdditionNotPresent);
      setTotalIfAdditionNotPresent(e.data.totalIfAdditionNotPresent);
      setListOfSPHInVerticalColumnIfAdditionNotPresent(e.data.listOfSPHInVerticalColumnIfAdditionNotPresent);

    };

    newWorker.onerror = (error) => {
      console.error("Worker error:", error);
    };

    // cleanup
    return () => {
      newWorker.terminate();
    };
  }, []);

  const [AxisValueList, setAxisValueList] = useState([]);

  const [isBifocal, setIsBifocal] = useState(false);

  const ShowButtonClickSV = async () => {
    ;
    let itmAxisMin = null,
      itmAxisMax = null;

    if (AxisValueList.length > 0) {
      itmAxisMin = Math.min(...AxisValueList);
      itmAxisMax = Math.max(...AxisValueList);
    }

    setIsBifocal(false);
    const dataToSend = {
      filter: {
        isBifocal: false,
        itmGrpD2Id: inputValues.ParentGrp ? inputValues.ParentGrp : 0,
        itmD2Id: inputValues.ItemId ? inputValues.ItemId : 0,
        itmSphMin: inputValues.SPH_Min
          ? inputValues.SPH_Min
          : inputValues.SPH_Min === 0
          ? 0
          : null,
        itmSphMax: inputValues.SPH_Max
          ? inputValues.SPH_Max
          : inputValues.SPH_Max === 0
          ? 0
          : null,
        itmCylMin: inputValues.CYL_Min
          ? inputValues.CYL_Min
          : inputValues.CYL_Min === 0
          ? 0
          : null,
        itmCylMax: inputValues.CYL_Max
          ? inputValues.CYL_Max
          : inputValues.CYL_Max === 0
          ? 0
          : null,
        itmAddMin: inputValues.Add_Min
          ? inputValues.Add_Min
          : inputValues.Add_Min === 0
          ? 0
          : null,
        itmAddMax: inputValues.Add_Max
          ? inputValues.Add_Max
          : inputValues.Add_Max === 0
          ? 0
          : null,
        itmAxisMin: inputValues.Axis
          ? inputValues.Axis
          : inputValues.Axis === 0
          ? 0
          : null,
        itmAxisMax: inputValues.Axis
          ? inputValues.Axis
          : inputValues.Axis === 0
          ? 0
          : null,
        itmEye: inputValues.Eye ? inputValues.Eye : null,
        pageNumber: 1,
        pageSize: pageSize,
      },

      lensCreation: inputValues,
    };

    try {
      setLoading(true);
      const response = await LensItemCreation.GetLensStockReport1(dataToSend);

      if (response.data.isSuccess) {
        setPage(1);
        let data = response.data.result;

        if (worker) {
          let dataForWorker = {
            stockData: data,
            lensCreation: inputValues,
            isBifocal: false,
            prevWholeTotal: 0,
          };

          worker.postMessage(dataForWorker);
        }

        setTotalRecords(response.data.totalRecords);
      } else {
        console.log(
          "Error in fetching lens stock",
          response.data.errorMessages
        );
        alert("Error in fetching lens stock");
      }
    } catch (error) {
      console.log("Error in fetching lens stock", error);
      alert("Error in fetching lens stock");
    }

    setLoading(false);
  };

  const ShowButtonClickPRO = async () => {
    let itmAxisMin = null,
      itmAxisMax = null;

    if (AxisValueList.length > 0) {
      itmAxisMin = Math.min(...AxisValueList);
      itmAxisMax = Math.max(...AxisValueList);
    }

    setIsBifocal(true);
    const dataToSend = {
      filter: {
        isBifocal: true,
        itmGrpD2Id: inputValues.ParentGrp ? inputValues.ParentGrp : 0,
        itmD2Id: inputValues.ItemId ? inputValues.ItemId : 0,
        itmSphMin: inputValues.SPH_Min
          ? inputValues.SPH_Min
          : inputValues.SPH_Min === 0
          ? 0
          : null,
        itmSphMax: inputValues.SPH_Max
          ? inputValues.SPH_Max
          : inputValues.SPH_Max === 0
          ? 0
          : null,
        itmCylMin: inputValues.CYL_Min
          ? inputValues.CYL_Min
          : inputValues.CYL_Min === 0
          ? 0
          : null,
        itmCylMax: inputValues.CYL_Max
          ? inputValues.CYL_Max
          : inputValues.CYL_Max === 0
          ? 0
          : null,
        itmAddMin: inputValues.Add_Min
          ? inputValues.Add_Min
          : inputValues.Add_Min === 0
          ? 0
          : null,
        itmAddMax: inputValues.Add_Max
          ? inputValues.Add_Max
          : inputValues.Add_Max === 0
          ? 0
          : null,
        itmAxisMin: inputValues.Axis
          ? inputValues.Axis
          : inputValues.Axis === 0
          ? 0
          : null,
        itmAxisMax: inputValues.Axis
          ? inputValues.Axis
          : inputValues.Axis === 0
          ? 0
          : null,
        itmEye: inputValues.Eye ? inputValues.Eye : null,
        pageNumber: 1,
        pageSize: pageSize,
      },

      lensCreation: inputValues,
    };

    try {
      setLoading(true);
      const response = await LensItemCreation.GetLensStockReport1(dataToSend);

      if (response.data.isSuccess) {
        setPage(1);
        let data = response.data.result;

        if (worker) {
          let dataForWorker = {
            stockData: data,
            lensCreation: inputValues,
            isBifocal: true,
          };

          worker.postMessage(dataForWorker);
        }

        setTotalRecords(response.data.totalRecords);
      } else {
        console.log(
          "Error in fetching lens stock",
          response.data.errorMessages
        );
        alert("Error in fetching lens stock");
      }
    } catch (error) {
      console.log("Error in fetching lens stock", error);
      alert("Error in fetching lens stock");
    }

    setLoading(false);
  };

  useEffect(() => {
    console.log("lensStockReport", lensStockReport);
    console.log("lensStockReport.length", lensStockReport.length);
  }, [lensStockReport]);

  const [ItemGroupList, setItemGroupList] = useState([]);
  const [ItemMasterList, setItemMasterList] = useState([]);

  useEffect(() => {
    const fetchItemGroupMaster = async () => {
      try {
        const val = await ItemGroupAPI.GetItemGroup();
        console.log(val);
        setItemGroupList(val);
      } catch (error) {
        console.log(error);
      }
    };

    fetchItemGroupMaster();
  }, []);
  const [isModalOpen2, setModalOpen2] = useState(false);

  const showModal2 = () => {
    setModalOpen2(!isModalOpen2);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    console.log(`Changing ${name} to ${value}`);

    setInputValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    //setErrorMessages((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  // const handleAxisChange = (event) => {
  //   ShowButtonClick(event.target.value);
  // };

  async function handlePageChange(page_num) {
    // if (AxisValueList.length > 0) {

    //   itmAxisMin = Math.min(...AxisValueList);
    //   itmAxisMax = Math.max(...AxisValueList);
    // }

    const dataToSend = {
      filter: {
        isBifocal: isBifocal,
        itmGrpD2Id: inputValues.ParentGrp ? inputValues.ParentGrp : 0,
        itmD2Id: inputValues.ItemId ? inputValues.ItemId : 0,
        itmSphMin: inputValues.SPH_Min
          ? inputValues.SPH_Min
          : inputValues.SPH_Min === 0
          ? 0
          : null,
        itmSphMax: inputValues.SPH_Max
          ? inputValues.SPH_Max
          : inputValues.SPH_Max === 0
          ? 0
          : null,
        itmCylMin: inputValues.CYL_Min
          ? inputValues.CYL_Min
          : inputValues.CYL_Min === 0
          ? 0
          : null,
        itmCylMax: inputValues.CYL_Max
          ? inputValues.CYL_Max
          : inputValues.CYL_Max === 0
          ? 0
          : null,
        itmAddMin: inputValues.Add_Min
          ? inputValues.Add_Min
          : inputValues.Add_Min === 0
          ? 0
          : null,
        itmAddMax: inputValues.Add_Max
          ? inputValues.Add_Max
          : inputValues.Add_Max === 0
          ? 0
          : null,
        itmAxisMin: inputValues.Axis
          ? inputValues.Axis
          : inputValues.Axis === 0
          ? 0
          : null,
        itmAxisMax: inputValues.Axis
          ? inputValues.Axis
          : inputValues.Axis === 0
          ? 0
          : null,
        itmEye: inputValues.Eye ? inputValues.Eye : null,
        pageNumber: page_num,
        pageSize: pageSize,
      },

      lensCreation: inputValues,
    };

    try {
      setLoading(true);
      const response = await LensItemCreation.GetLensStockReport1(dataToSend);

      if (response.data.isSuccess) {
        let data = response.data.result;

        if (worker) {
          let dataForWorker = {
            prevStockData: lensStockReport,
            prevColumnWiseTotal: lensStockReportColWiseTotal,
            stockData: data,
            lensCreation: inputValues,
            isBifocal: isBifocal,
            prevWholeTotal: wholeTotal,
          };

          worker.postMessage(dataForWorker);
        }

        setTotalRecords(response.data.totalRecords);
      } else {
        console.log(
          "Error in fetching lens stock",
          response.data.errorMessages
        );
        alert("Error in fetching lens stock");
      }
    } catch (error) {
      console.log("Error in fetching lens stock", error);
      alert("Error in fetching lens stock");
    }

    setLoading(false);
  }

  useEffect(() => {
    if (inputValues.ItemId && page !== 1) {
      handlePageChange(page);
    }
  }, [page]);

  function handlePrevClick() {
    return;
    if (page == 1) return;

    setPage(page - 1);
  }

  function handleNextClick() {
    if (page == Math.ceil(totalRecords / pageSize)) return;

    setPage(page + 1);
  }

  const [filteredItems, setFilteredItems] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleInputChange1 = async (event) => {
    const { name, value } = event.target;
    console.log(`Changing ${name} to ${value}`);

    setInputValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));

    setIsDropdownOpen(true);
    const filteredData = {
      MasterType: 4,
      IsAttributeParent: true,
      GroupWiseSuggestion: false,
      GroupId: "",
      search_str: value,
      PageNumber: 1,
      PageSize: 15,
      IsEcomStore: false,
    };
    const searchItem1 = await Account.GetAccountListForAutoSuggestion(
      filteredData
    );
    setFilteredItems(searchItem1);
    setHighlightedIndex(-1);
  };

  const [isExistingItem, setIsExistingItem] = useState(false);
  const [axisValueForExisting, setAxisValueForExisting] = useState([]);

  const handleSelection = async (id, name, parentGrpId) => {
    ;
    const data = await LensItemCreation.getLensItemCreationByItemId(id);

    if (data) {
      setIsExistingItem(true);

      ;
      const numbersArray = data.axis.split(",").map((num) => Number(num));

      let axis = numbersArray?.length > 0 ? numbersArray[0] : "";

      setInputValues((prevValues) => ({
        ...prevValues,
        ItemId: id,
        ItemName: name,
        ParentGrp: parentGrpId,
        SPH_Min: data.spH_Min,
        SPH_Max: data.spH_Max,
        SPH_Step: data.spH_Step,
        CYL_Min: data.cyL_Min,
        CYL_Max: data.cyL_Max,
        CYL_Step: data.cyL_Step,
        Axis: axis,
        Add_Min: data.add_Min,
        Add_Max: data.add_Max,
        Add_Step: data.add_Step,
        Eye: data.eye,
      }));

      if (numbersArray?.length && numbersArray?.length > 0) {
        setAxisValueList(numbersArray);
      } else {
        setAxisValueList([]);
      }
    } else {
      Swal.fire({
        icon: "warning",
        title: "No Power Created",
        text: "Please create power first to view stock details.",
        timer: 4000,
        showConfirmButton: false,
        timerProgressBar: true,
        width: "250px",
        customClass: {
          title: "swal2-custom-title",
          confirmButton: "my-confirm-button",
          cancelButton: "my-cancel-button",
          popup: "swal2-custom-popup",
          htmlContainer: "swal2-custom-text",
          icon: "swal2-custom-icon",
        },
      });

      setIsExistingItem(false);
      setInputValues({
        ParentGrp: "",
        ItemName: "",
        ItemId: "",
        SPH_Min: "",
        SPH_Max: "",
        SPH_Step: "",
        CYL_Min: "",
        CYL_Max: "",
        CYL_Step: "",
        Add_Min: "",
        Add_Max: "",
        Add_Step: "",
        Eye: "",
        Axis: "",
      });

      setAxisValueList([]);
    }

    setIsDropdownOpen(false);
  };

  const handleKeyDownForProduct = (e) => {
    if (isDropdownOpen) {
      switch (e.key) {
        case "ArrowDown":
          e.preventDefault();
          setHighlightedIndex((prevIndex) =>
            prevIndex < filteredItems.length - 1 ? prevIndex + 1 : prevIndex
          );
          break;
        case "ArrowUp":
          e.preventDefault();
          setHighlightedIndex((prevIndex) =>
            prevIndex > 0 ? prevIndex - 1 : prevIndex
          );
          break;
        case "Enter":
          if (
            highlightedIndex >= 0 &&
            highlightedIndex < filteredItems.length
          ) {
            const selectedItem = filteredItems[highlightedIndex];
            handleSelection(
              selectedItem.id,
              selectedItem.name,
              selectedItem.parentGrpId
            );
          }
          break;
        case "Escape":
          setIsDropdownOpen(false);
          break;
        default:
          break;
      }
    }
  };

  useEffect(() => {
    console.log("AxisValueList", AxisValueList);
  }, [AxisValueList]);

  useEffect(() => {
    // Auto-scroll the dropdown to ensure the highlighted item is always in view
    if (dropdownRef.current && highlightedIndex >= 0) {
      const listItem = dropdownRef.current.children[highlightedIndex];
      if (listItem) {
        const listContainer = dropdownRef.current;
        const itemTop = listItem.offsetTop;
        const itemBottom = itemTop + listItem.offsetHeight;
        const containerTop = listContainer.scrollTop;
        const containerBottom = containerTop + listContainer.offsetHeight;

        // If the item is out of view, scroll the container
        if (itemTop < containerTop) {
          listContainer.scrollTop = itemTop; // scroll to top of item
        } else if (itemBottom > containerBottom) {
          listContainer.scrollTop = itemBottom - listContainer.offsetHeight; // scroll to bottom of item
        }
      }
    }
  }, [highlightedIndex]);

  // const [selectedItemIndex, setSelectedItemIndex] = useState(-1);
  // const [focusedIndex, setFocusedIndex] = useState(-1);

  // const handleKeyDown = (event) => {
  //     if (event.key === "ArrowDown") {
  //         event.preventDefault();
  //         setFocusedIndex((prevIndex) => Math.min(prevIndex + 1, filteredItems.length - 1));
  //     } else if (event.key === "ArrowUp") {
  //         event.preventDefault();
  //         setFocusedIndex((prevIndex) => Math.max(prevIndex - 1, -1));
  //     } else if (event.key === "Enter" && focusedIndex !== -1) {
  //         event.preventDefault();
  //         const selectedItem = filteredItems[focusedIndex];
  //         handleSelection(selectedItem.d2Id, selectedItem.name);
  //         setFocusedIndex(-1);
  //     }
  // };

  const [dataToSendInUpdate, setDataToSendInUpdate] = useState([]);

  useEffect(() => {
    console.log("dataToSendInUpdate", dataToSendInUpdate);
  }, [dataToSendInUpdate.length]);


  const [showStaticUnit, setShowStaticUnit] = useState(false);

  return (
    <div style={{ backgroundColor: "white" }}>
      {/* *******************Top Navbar/Buttons****************** */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#212e4f",
        }}
      >
        <div className="panel-head-title">
          <h2
            className="panel-title"
            style={{ color: "white", fontWeight: "600" }}
          >
            Lens Stock
          </h2>
        </div>
        <MainButton saveButtonHide={true} />
      </div>
      {/* ******************* Body ****************** */}
      <div className="mt-1" style={{ padding: "15px", position: "relative" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "start",
            marginLeft: "12px",
            alignItems: "center",
          }}
        >
          <label>Group Name &nbsp;</label>
          <select
            style={{
              width: "120px",
              padding: "5px , 10px",
              marginRight: "15px",
            }}
            className="table-input"
            onChange={handleInputChange}
            value={inputValues.ParentGrp}
            name="ParentGrp"
          >
            <option>-Select-</option>
            {ItemGroupList !== undefined &&
            ItemGroupList !== null &&
            ItemGroupList.length > 0 ? (
              ItemGroupList.map((group, index) => (
                <option key={index} value={group.d2_Id}>
                  {group.name}
                </option>
              ))
            ) : (
              <option value="">No groups available</option>
            )}
          </select>
          <label> &nbsp; Product Name &nbsp;</label>

          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              onKeyDown={handleKeyDownForProduct}
              type="text"
              className="table-input"
              style={{ width: "150px", padding: "5px , 10px" }}
              value={inputValues.ItemName}
              name="ItemName"
              onChange={handleInputChange1}
              placeholder="Type to search..."
              onBlur={() => {
                setTimeout(() => {
                  setIsDropdownOpen(false);
                }, 500);
              }}
              autoComplete="off"
            />
            {/* <div style={{ paddingLeft: "3px" }} onClick={showModal2}>
              <i className="fa-solid fa-circle-plus dm_4"></i>
            </div> */}
            <ul
              ref={dropdownRef}
              style={{
                display: isDropdownOpen ? "block" : "none",
                position: "absolute",
                maxHeight: "250px",
                padding: "0",
                width: "250px",
                top: "50px",
                zIndex: 999,
                fontSize: "15px",
                backgroundColor: "white",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                overflow: "auto",
              }}
            >
              {filteredItems.map((item, index) => (
                <li
                  key={index}
                  onClick={() =>
                    handleSelection(item.id, item.name, item.parentGrpId)
                  }
                  style={{
                    cursor: "pointer",
                    borderBottom: "1px solid #ccc",
                    padding: "5px 10px",
                    margin: "0",
                    backgroundColor:
                      highlightedIndex === index ? "#eee" : "white",
                  }}
                >
                  {item.name}
                </li>
              ))}
            </ul>
            {/* <ul style={{
                            display: isDropdownOpen ? "block" : "none", position: "absolute", height: "250px", width: "400px",
                            // top: "calc(25% + 5px)", left: "calc(35%)", 
                            zIndex: 999, backgroundColor: "white",
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", overflow: "auto"
                        }}>
                            {filteredItems.map((item, index) => (
                                //console.log(item),
                                <li key={index} onClick={() => handleSelection(item.d1Id, item.name)} style={{ padding: "5px", cursor: "pointer", borderBottom: "1px solid #ccc" }}>
                                    {item.name}
                                </li>
                            ))}
                        </ul> */}
          </div>
        </div>

        {/* <label className="col-sm-3 w-8">Power Range</label> */}
        <div className="ToolTipTOp">
          {/* <div className="input-box-SI-2 ">
                        <div className="input-box-m6">
                            <div className="row">
                                <label className="col-sm-3 w-8" ></label>
                            </div>
                        </div>
                    </div> */}
          <div className="mt-1">
            <div className="input-box-m6">
              <div className="flex space-around" style={{ flexWrap: "nowrap" }}>
                <div style={{ width: "auto" }} class="tooltip6">
                  <label
                    className=" "
                    style={{ textAlign: "center", marginLeft: "5px" }}
                  >
                    SPH Min
                  </label>
                  <input
                    id="sph_min"
                    className=" table-input box-size1 toolTextWdth"
                    value={inputValues.SPH_Min}
                    onChange={handleInputChange}
                    name="SPH_Min"
                    type="number"
                    required
                  />
                  <div class="tooltiptext">SPH Range -40.00 to +40.00</div>
                </div>

                <div style={{ width: "auto" }} class="tooltip6">
                  <label
                    className=" "
                    style={{ textAlign: "center", marginLeft: "5px" }}
                  >
                    SPH Max
                  </label>
                  <input
                    id="sph_max"
                    className=" table-input box-size1 toolTextWdth"
                    value={inputValues.SPH_Max}
                    onChange={handleInputChange}
                    name="SPH_Max"
                    type="number"
                    required
                  />
                  <div class="tooltiptext">SPH Range -40.00 to +40.00</div>
                </div>

                {/* <div style={{ width: "auto" }} class="tooltip6">
                  <label
                    className=" "
                    style={{ textAlign: "center", marginLeft: "5px" }}
                  >
                    Step
                  </label>
                  <input
                    id="sph_step"
                    className=" table-input box-size1 toolTextWdth"
                    value={inputValues.SPH_Step}
                    onChange={handleInputChange}
                    name="SPH_Step"
                    type="number"
                    required
                  />
                  <div class="tooltiptext">Step 0.25</div>
                </div> */}

                <div style={{ width: "auto" }} class="tooltip6">
                  <label
                    className=" "
                    style={{ textAlign: "center", marginLeft: "5px" }}
                  >
                    CYL Min
                  </label>
                  <input
                    id="cyl_min"
                    className=" table-input box-size1 toolTextWdth"
                    value={inputValues.CYL_Min}
                    onChange={handleInputChange}
                    name="CYL_Min"
                    type="number"
                    required
                  />
                  <div class="tooltiptext">CYL Range -10.00 to +10.00</div>
                </div>

                <div style={{ width: "auto" }} class="tooltip6">
                  <label
                    className=" "
                    style={{ textAlign: "center", marginLeft: "5px" }}
                  >
                    CYL Max
                  </label>
                  <input
                    id="cyl_max"
                    className=" table-input box-size1 toolTextWdth"
                    value={inputValues.CYL_Max}
                    onChange={handleInputChange}
                    name="CYL_Max"
                    type="number"
                    required
                  />
                  <div class="tooltiptext">CYL Range -10.00 to +10.00</div>
                </div>

                {/* <div style={{ width: "auto" }} class="tooltip6">
                  <label
                    className=" "
                    style={{ textAlign: "center", marginLeft: "5px" }}
                  >
                    Step
                  </label>
                  <input
                    id="cyl_step"
                    className=" table-input box-size1 toolTextWdth"
                    value={inputValues.CYL_Step}
                    // onChange={handleInputChange}
                    name="CYL_Step"
                    type="number"
                    required
                  />
                  <div class="tooltiptext">Step 0.25</div>
                </div> */}

                <div style={{ width: "15%" }} class="tooltip6">
                  <label
                    className=" "
                    style={{ textAlign: "center", marginLeft: "5px" }}
                  >
                    Axis
                  </label>

                  <select
                    name="Axis"
                    id="axis"
                    onChange={handleInputChange}
                    value={inputValues.Axis}
                    className=" table-input box-size1 toolTextWdth"
                  >
                    <option value="">--Select--</option>
                    {AxisValueList.map((axis, index) => (
                      <option key={index} value={axis}>
                        {axis}
                      </option>
                    ))}
                  </select>
                  {/* <input
                    id="axis"
                    className=" table-input box-size1 toolTextWdth"
                    value={inputValues.Axis}
                    onChange={handleInputChange}
                    name="Axis"
                    type="text"
                    required
                  /> */}
                  <div class="tooltiptext">Select Axis</div>
                </div>

                <div style={{ width: "auto" }} class="tooltip6">
                  <label
                    className=" "
                    style={{ textAlign: "center", marginLeft: "5px" }}
                  >
                    Add Min
                  </label>
                  <input
                    id="add_min"
                    className=" table-input box-size1 toolTextWdth"
                    value={inputValues.Add_Min}
                    onChange={handleInputChange}
                    name="Add_Min"
                    type="number"
                    required
                  />
                  <div class="tooltiptext">Add Range 0.50 to +10.00</div>
                </div>

                <div style={{ width: "auto" }} class="tooltip6">
                  <label
                    className=" "
                    style={{ textAlign: "center", marginLeft: "5px" }}
                  >
                    Add Max
                  </label>
                  <input
                    id="add_max"
                    className=" table-input box-size1 toolTextWdth"
                    value={inputValues.Add_Max}
                    onChange={handleInputChange}
                    name="Add_Max"
                    type="number"
                    required
                  />
                  <div class="tooltiptext">Add Range 0.50 to +10.00</div>
                </div>

                {/* <div style={{ width: "auto" }} class="tooltip6">
                  <label
                    className=" "
                    style={{ textAlign: "center", marginLeft: "5px" }}
                  >
                    Step
                  </label>
                  <input
                    id="add_step"
                    className=" table-input box-size1 toolTextWdth"
                    value={inputValues.Add_Step}
                    onChange={handleInputChange}
                    name="Add_Step"
                    type="number"
                    required
                  />
                  <div class="tooltiptext">Step 0.25</div>
                </div> */}

                <div style={{ width: "15%" }} class="tooltip6">
                  <label
                    className=" "
                    style={{ textAlign: "center", marginLeft: "5px" }}
                  >
                    Eye(RL/R/L)
                  </label>
                  <select
                    className="modify_im_input mode_category table-input"
                    style={{ width: "100%" }}
                    value={inputValues.Eye}
                    onChange={handleInputChange}
                    name="Eye"
                    type="text"
                    required
                  >
                    <option value="" disabled></option>
                    <option value="R">R</option>
                    <option value="L">L</option>
                    <option value="RL">RL</option>
                  </select>

                  <div class="tooltiptext">R/L/RL</div>
                </div>

                <div style={{ width: "230px" }} class="tooltip6">
                  <button
                    // className="ml-10 btn-red table-input box-size1 mt-2"
                    className="btn-blue ml-10"
                    onMouseEnter={() => setIsHovered3(true)}
                    onMouseLeave={() => setIsHovered3(false)}
                    onClick={() => ShowButtonClickSV()}
                    type="number"
                    required
                    style={{
                      backgroundColor: "darkgreen",
                      padding: "3px 0px",
                      height: "auto",
                      width: "100%",
                      border: "none",
                      transform: "translateY(8px)",
                    }}
                  >
                    Show
                  </button>
                </div>

                <div style={{ width: "230px" }} class="tooltip6">
                  <button
                    // className="ml-10 btn-red table-input box-size1 mt-2"
                    className="btn-blue ml-10"
                    onMouseEnter={() => setIsHovered3(true)}
                    onMouseLeave={() => setIsHovered3(false)}
                    onClick={() => ShowButtonClickPRO()}
                    type="number"
                    required
                    style={{
                      backgroundColor: "darkgreen",
                      padding: "3px 0px",
                      height: "auto",
                      width: "100%",
                      border: "none",
                      transform: "translateY(8px)",
                    }}
                  >
                    Progressive
                  </button>
                </div>
                {/* {isHovered14 && <div className="hover-text2" style={{ marginLeft: "61%" }}></div>} */}
              </div>
            </div>
          </div>
        </div>

        {isAdditionPresent ?
          (lensStockReportCol.length > 0 && (

            <>
              <div className="mt-3 lens-stock-table-container" id="LensTable">
                <table className="lens-stock-table">
                  <thead style={{ height: "40px" }}>
                    <tr>
                      {/* <th
                      style={{
                        position: "sticky",
                        left: "0px",
                        zIndex: 4,
                        width: "50px"
                      }}
                      className="lens-stock-table-th">S.No.</th> */}

                      {lensStockReportCol.map((collapseToast, index) => (
                        <th
                          style={
                            collapseToast.name == "Lens_SPH" ||
                              collapseToast.name == "Lens_CYL" ||
                              collapseToast.name == "Lens_EYE" ||
                              collapseToast.name == "Axis"
                              ? {
                                position: "sticky",
                                left: `${(index + 0) * 50}px`,
                                top: "-2px",
                                zIndex: 6,
                                minWidth: "50px",
                                maxWidth: "50px",
                              }
                              : {
                                position: "sticky",
                                top: "-2px",
                                zIndex: 5,
                              }
                          }
                          key={index}
                          className="lens-stock-table-th"
                        >
                          {" "}
                          {collapseToast.printName}
                        </th>
                      ))}
                    </tr>
                  </thead>

                <tbody>
                  {lensStockReport.map((item, index) => (
                    <tr key={index} className="TrLensCreation">
                      {/* <td
                        style={{
                          position: "sticky",
                          left: "0px",
                          zIndex: 3,
                          width: "50px"
                        }}
                        className="firstColumnCellStyle tableData rows_indicator ButtonStick1 lens-stock-table-td">
                        {index + 1}
                      </td> */}

                      {lensStockReportCol.map((col, cIndex) => {
                        if (typeof item[col.name] == "object") {
                          return (
                            <td
                              key={`${index}-${cIndex}`}
                              style={
                                col.name == "Lens_SPH" ||
                                col.name == "Lens_CYL" ||
                                col.name == "Lens_EYE" ||
                                col.name == "Axis"
                                  ? {
                                      position: "sticky",
                                      left: `${(cIndex + 0) * 50}px`,
                                      zIndex: 4,
                                      minWidth: "50px",
                                      maxWidth: "50px",
                                    }
                                    : {
                                      position: "sticky",
                                      zIndex: 3,
                                    }
                                }
                                className={`firstColumnCellStyle tableData rows_indicator ButtonStick1 lens-stock-table-td ${col.name == "Lens_SPH" ||
                                  col.name == "Lens_CYL" ||
                                  col.name == "Lens_EYE" ||
                                  col.name == "Axis"
                                  ? "lens-stock-table-td-color"
                                  : ""
                                  }`}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >

                                  {item[`${col.name}_isDeleted`] ? '-' : (

                                    <>

                                      <td style={{width:"max-content"}}>
                                        <strong>RL:</strong>
                                        {item[col.name]["rl"] &&
                                          item[col.name]["rl"].map(
                                            (stock, sIndex) => {
                                              if (sIndex == 0) {
                                                if (showStaticUnit) {
                                                  return (
                                                    <span key={sIndex}>
                                                      {stock.stock}{" "}
                                                      <sub>({"PRS-PAIRS"})</sub>
                                                    </span>
                                                  );
                                                } else {
                                                  return (
                                                    <span key={sIndex}>
                                                      {stock.stock}{" "}
                                                      <sub>({stock.unit})</sub>
                                                    </span>
                                                  );
                                                }
                                              } else {
                                                if (showStaticUnit) {
                                                  return (
                                                    <span key={sIndex}>
                                                      {stock.stock}{" "}
                                                      <sub>({"PRS-PAIRS"})</sub>
                                                    </span>
                                                  );
                                                } else {
                                                  return (
                                                    <span key={sIndex}>
                                                      {stock.stock}{" "}
                                                      <sub>({stock.unit})</sub>
                                                    </span>
                                                  );
                                                }
                                              }
                                            }
                                          )}
                                      </td>
                                      <td style={{width:"max-content"}}>
                                        <strong>R:</strong>
                                        {item[col.name]["r"] &&
                                          item[col.name]["r"].map((stock, sIndex) => {
                                            if (sIndex == 0) {
                                              if (showStaticUnit) {
                                                return (
                                                  <span key={sIndex}>
                                                    {stock.stock}{" "}
                                                    <sub>({"PCS-PIECES"})</sub>
                                                  </span>
                                                );
                                              } else {
                                                return (
                                                  <span key={sIndex}>
                                                    {stock.stock}{" "}
                                                    <sub>({stock.unit})</sub>
                                                  </span>
                                                );
                                              }
                                            } else {
                                              if (showStaticUnit) {
                                                return (
                                                  <span key={sIndex}>
                                                    {stock.stock}{" "}
                                                    <sub>({"PCS-PIECES"})</sub>
                                                  </span>
                                                );
                                              } else {
                                                return (
                                                  <span key={sIndex}>
                                                    {stock.stock}{" "}
                                                    <sub>({stock.unit})</sub>
                                                  </span>
                                                );
                                              }
                                            }
                                          })}
                                      </td>
                                      <td style={{width:"max-content"}}>
                                        <strong>L:</strong>
                                        {item[col.name]["l"] &&
                                          item[col.name]["l"].map((stock, sIndex) => {
                                            if (sIndex == 0) {
                                              if (showStaticUnit) {
                                                return (
                                                  <span key={sIndex}>
                                                    {stock.stock}{" "}
                                                    <sub>({"PCS-PIECES"})</sub>
                                                  </span>
                                                );
                                              } else {
                                                return (
                                                  <span key={sIndex}>
                                                    {stock.stock}{" "}
                                                    <sub>({stock.unit})</sub>
                                                  </span>
                                                );
                                              }
                                            } else {
                                              if (showStaticUnit) {
                                                return (
                                                  <span key={sIndex}>
                                                    {stock.stock}{" "}
                                                    <sub>({"PCS-PIECES"})</sub>
                                                  </span>
                                                );
                                              } else {
                                                return (
                                                  <span key={sIndex}>
                                                    {stock.stock}{" "}
                                                    <sub>({stock.unit})</sub>
                                                  </span>
                                                );
                                              }
                                            }
                                          })}
                                      </td>

                                    </>
                                  )}



                                </div>
                              </td>
                            );
                          } else {
                            return (
                              <td
                                key={`${index}-${cIndex}`}
                                style={
                                  col.name == "Lens_SPH" ||
                                    col.name == "Lens_CYL" ||
                                    col.name == "Lens_EYE" ||
                                    col.name == "Axis"
                                    ? {
                                      position: "sticky",
                                      left: `${(cIndex + 0) * 50}px`,
                                      zIndex: 4,
                                      minWidth: "50px",
                                      maxWidth: "50px",
                                    }
                                    : {
                                      position: "sticky",
                                      zIndex: 3,
                                    }
                                }
                                className={`firstColumnCellStyle tableData rows_indicator ButtonStick1 lens-stock-table-td ${col.name == "Lens_SPH" ||
                                  col.name == "Lens_CYL" ||
                                  col.name == "Lens_EYE" ||
                                  col.name == "Axis"
                                  ? "lens-stock-table-td-color"
                                  : ""
                                  }`}
                              >
                                {item[`${col.name}_isDeleted`] ? '-' : item[col.name]}
                              </td>
                            );
                          }
                        })}
                      </tr>
                    ))}

                  <tr className="TrLensCreation">
                    {/* <td
                      style={{
                        position: "sticky",
                        left: "0px",
                        zIndex: 3,
                        width: "50px"
                      }}
                      className="firstColumnCellStyle tableData rows_indicator ButtonStick1 lens-stock-table-td">

                    </td> */}

                      <td
                        colSpan={numberOfFirstNotAddColumns}
                        style={{
                          position: "sticky",
                          left: `${0 * 100}px`,
                          zIndex: 5,
                          minWidth: "100px",
                        }}
                        className="firstColumnCellStyle tableData rows_indicator ButtonStick1 lens-stock-table-td lens-stock-table-td-color"
                      >
                        Total
                      </td>

                    {lensStockReportCol.map((col, cIndex) => {
                      if (col.name.startsWith("Add")) {
                        if (
                          typeof lensStockReportColWiseTotal[col.name] ==
                          "object"
                        ) {
                          return (
                            <td
                              key={`${cIndex}`}
                              className="firstColumnCellStyle tableData rows_indicator ButtonStick1 lens-stock-table-td"
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <td>
                                  <strong>RL:</strong>{" "}
                                  {lensStockReportColWiseTotal[col.name][
                                    "rl"
                                  ].map((stock, sIndex) => {
                                    if (sIndex == 0) {
                                      if (showStaticUnit) {
                                        return (
                                          <span key={sIndex}>
                                            {stock.stock}{" "}
                                            <sub>({"PRS-PAIRS"})</sub>
                                          </span>
                                        );
                                      } else {
                                        return (
                                          <span key={sIndex}>
                                            {stock.stock}{" "}
                                            <sub>({stock.unit})</sub>
                                          </span>
                                        );
                                      }
                                    } else {
                                      if (showStaticUnit) {
                                        return (
                                          <span key={sIndex}>
                                            {stock.stock}{" "}
                                            <sub>({"PRS-PAIRS"})</sub>
                                          </span>
                                        );
                                      } else {
                                        return (
                                          <span key={sIndex}>
                                            {stock.stock}{" "}
                                            <sub>({stock.unit})</sub>
                                          </span>
                                        );
                                      }
                                    }
                                  })}
                                </td>
                                <td>
                                  <strong>R:</strong>{" "}
                                  {lensStockReportColWiseTotal[col.name][
                                    "r"
                                  ].map((stock, sIndex) => {
                                    if (sIndex == 0) {
                                      if (showStaticUnit) {
                                        return (
                                          <span key={sIndex}>
                                            {stock.stock}{" "}
                                            <sub>({"PCS-PIECES"})</sub>
                                          </span>
                                        );
                                      } else {
                                        return (
                                          <span key={sIndex}>
                                            {stock.stock}{" "}
                                            <sub>({stock.unit})</sub>
                                          </span>
                                        );
                                      }
                                    } else {
                                      if (showStaticUnit) {
                                        return (
                                          <span key={sIndex}>
                                            {stock.stock}{" "}
                                            <sub>({"PCS-PIECES"})</sub>
                                          </span>
                                        );
                                      } else {
                                        return (
                                          <span key={sIndex}>
                                            {stock.stock}{" "}
                                            <sub>({stock.unit})</sub>
                                          </span>
                                        );
                                      }
                                    }
                                  })}
                                </td>
                                <td>
                                  <strong>L:</strong>{" "}
                                  {lensStockReportColWiseTotal[col.name][
                                    "l"
                                  ].map((stock, sIndex) => {
                                    if (sIndex == 0) {
                                      if (showStaticUnit) {
                                        return (
                                          <span key={sIndex}>
                                            {stock.stock}{" "}
                                            <sub>({"PCS-PIECES"})</sub>
                                          </span>
                                        );
                                      } else {
                                        return (
                                          <span key={sIndex}>
                                            {stock.stock}{" "}
                                            <sub>({stock.unit})</sub>
                                          </span>
                                        );
                                      }
                                    } else {
                                      if (showStaticUnit) {
                                        return (
                                          <span key={sIndex}>
                                            {stock.stock}{" "}
                                            <sub>({"PCS-PIECES"})</sub>
                                          </span>
                                        );
                                      } else {
                                        return (
                                          <span key={sIndex}>
                                            {stock.stock}{" "}
                                            <sub>({stock.unit})</sub>
                                          </span>
                                        );
                                      }
                                    }
                                  })}
                                </td>
                              </div>
                            </td>
                          );
                        } else {
                          return (
                            <td
                              key={`${cIndex}`}
                              className="firstColumnCellStyle tableData rows_indicator ButtonStick1 lens-stock-table-td"
                            >
                              {lensStockReportColWiseTotal[col.name]}
                            </td>
                          );
                        }
                      }
                    })}

                      {typeof wholeTotal == "object" ? (
                        <td className="firstColumnCellStyle tableData rows_indicator ButtonStick1 lens-stock-table-td">
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <td style={{width:"max-content"}}>
                              <strong>RL:</strong>{" "}
                              {wholeTotal["rl"].map((stock, sIndex) => {
                                if (sIndex == 0) {
                                  if (showStaticUnit) {
                                    return (
                                      <span key={sIndex}>
                                        {stock.stock} <sub>({"PRS-PAIRS"})</sub>
                                      </span>
                                    );
                                  } else {
                                    return (
                                      <span key={sIndex}>
                                        {stock.stock} <sub>({stock.unit})</sub>
                                      </span>
                                    );
                                  }
                                } else {
                                  if (showStaticUnit) {
                                    return (
                                      <span key={sIndex}>
                                        {stock.stock} <sub>({"PRS-PAIRS"})</sub>
                                      </span>
                                    );
                                  } else {
                                    return (
                                      <span key={sIndex}>
                                        {stock.stock} <sub>({stock.unit})</sub>
                                      </span>
                                    );
                                  }
                                }
                              })}
                            </td>
                            <td style={{width:"max-content"}}>
                              <strong>R:</strong>{" "}
                              {wholeTotal["r"].map((stock, sIndex) => {
                                if (sIndex == 0) {
                                  if (showStaticUnit) {
                                    return (
                                      <span key={sIndex}>
                                        {stock.stock} <sub>({"PCS-PIECES"})</sub>
                                      </span>
                                    );
                                  } else {
                                    return (
                                      <span key={sIndex}>
                                        {stock.stock} <sub>({stock.unit})</sub>
                                      </span>
                                    );
                                  }
                                } else {
                                  if (showStaticUnit) {
                                    return (
                                      <span key={sIndex}>
                                        {stock.stock} <sub>({"PCS-PIECES"})</sub>
                                      </span>
                                    );
                                  } else {
                                    return (
                                      <span key={sIndex}>
                                        {stock.stock} <sub>({stock.unit})</sub>
                                      </span>
                                    );
                                  }
                                }
                              })}
                            </td>
                            <td style={{width:"max-content"}}>
                              <strong>L:</strong>{" "}
                              {wholeTotal["l"].map((stock, sIndex) => {
                                if (sIndex == 0) {
                                  if (showStaticUnit) {
                                    return (
                                      <span key={sIndex}>
                                        {stock.stock} <sub>({"PCS-PIECES"})</sub>
                                      </span>
                                    );
                                  } else {
                                    return (
                                      <span key={sIndex}>
                                        {stock.stock} <sub>({stock.unit})</sub>
                                      </span>
                                    );
                                  }
                                } else {
                                  if (showStaticUnit) {
                                    return (
                                      <span key={sIndex}>
                                        {stock.stock} <sub>({"PCS-PIECES"})</sub>
                                      </span>
                                    );
                                  } else {
                                    return (
                                      <span key={sIndex}>
                                        {stock.stock} <sub>({stock.unit})</sub>
                                      </span>
                                    );
                                  }
                                }
                              })}
                            </td>
                          </div>
                        </td>
                      ) : (
                        <td className="firstColumnCellStyle tableData rows_indicator ButtonStick1 lens-stock-table-td">
                          {wholeTotal}
                        </td>
                      )}
                      {/* <td className="firstColumnCellStyle tableData rows_indicator ButtonStick1 lens-stock-table-td">
                      {typeof wholeTotal == "object" ? `${wholeTotal.rl} \n ${wholeTotal.r} \n ${wholeTotal.l}` : wholeTotal}
                    </td> */}
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          ))
          : (<>
            <div className="mt-3 lens-stock-table-container" id="LensTable">
              <table className="lens-stock-table">

                <thead style={{ height: "40px", position: "sticky", top: "-2px", zIndex: 3 }}>
                  <tr>
                    {columns1IfAdditionNotPresent.map((col, index) => (

                      <th key={index} style={(col.name == "Lens_SPH" || col.name == "Lens_CYL") ? { position: "sticky", left: "0px", zIndex: 3 } : {}} className="lens-stock-table-th">{col.printName}</th>
                    ))}
                  </tr>

                  <tr>
                    {columns2IfAdditionNotPresent.map((col, index) => (

                      <th key={index} style={(col.name == "Lens_SPH" || col.name == "Lens_CYL") ? { backgroundColor: "#DCDCDD", color: "black", position: "sticky", left: "0px", zIndex: 3 } : { backgroundColor: "#DCDCDD", color: "black" }} className="lens-stock-table-th">{col.printName}</th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {rowsIfAdditionNotPresent.map((row, index) => (
                    <tr key={index} className="TrLensCreation">

                      {columns1IfAdditionNotPresent.map((col, index1) => {


                        if (typeof row[col.name] == "object") {

                          return (
                            <td key={`${index}-${index1}`} style={col.name == "Lens_CYL" ? { backgroundColor: "#DCDCDD", color: "black", position: "sticky", left: "0px", zIndex: 2, height: "30px" } : { backgroundColor: "white", color: "black", height: "30px" }} className={col.name == "Lens_CYL" ? "lens-stock-table-td-color" : "lens-stock-table-td"}>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >

                                <>

                                  <td style={{width:"max-content"}}>
                                    <strong>RL:</strong>

                                    {showStaticUnit ? (
                                      <span >
                                        {row[col.name]["rl"][0]?.stock}{" "}
                                        <sub>({"PRS-PAIRS"})</sub>
                                      </span>
                                    ) : (
                                      <span>
                                        {row[col.name]["rl"][0]?.stock}{" "}
                                        <sub>({row[col.name]["rl"][0]?.unit})</sub>
                                      </span>
                                    )}

                                  </td>
                                  <td style={{width:"max-content"}}>
                                    <strong>R:</strong>


                                    {showStaticUnit ? (
                                      <span >
                                        {row[col.name]["r"][0]?.stock}{" "}
                                        <sub>({"PCS-PIECES"})</sub>
                                      </span>
                                    ) : (
                                      <span>
                                        {row[col.name]["r"][0]?.stock}{" "}
                                        <sub>({row[col.name]["r"][0]?.unit})</sub>
                                      </span>
                                    )}

                                  </td>
                                  <td style={{width:"max-content"}}>
                                    <strong>L:</strong>

                                    {showStaticUnit ? (
                                      <span >
                                        {row[col.name]["l"][0]?.stock}{" "}
                                        <sub>({"PCS-PIECES"})</sub>
                                      </span>
                                    ) : (
                                      <span>
                                        {row[col.name]["l"][0]?.stock}{" "}
                                        <sub>({row[col.name]["l"][0]?.unit})</sub>
                                      </span>
                                    )}


                                  </td>

                                </>

                              </div>
                            </td>

                          );

                        } else {

                          return (


                            <td key={`${index}-${index1}`} style={col.name == "Lens_CYL" ? { backgroundColor: "#DCDCDD", color: "black", position: "sticky", left: "0px", zIndex: 2, height: "30px" } : { backgroundColor: "white", color: "black", height: "30px" }}  className={col.name == "Lens_CYL" ?"lens-stock-table-td-color" : "lens-stock-table-td"} >
                              {col.name == "Lens_CYL" ? row["Lens_SPH"] : row[col.name]}
                            </td>
                          );

                        }

                      })}

                    </tr>
                  ))}

                  <tr className="TrLensCreation">

                    <td colSpan={columns2IfAdditionNotPresent.length - 1}
                      className="firstColumnCellStyle tableData rows_indicator ButtonStick1 lens-stock-table-td"
                    >Total</td>

                    <td className="firstColumnCellStyle tableData rows_indicator ButtonStick1 lens-stock-table-td">

                      {typeof totalIfAdditionNotPresent == "object" ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >

                          <>

                            <td style={{width:"max-content"}}>
                              <strong>RL:</strong>

                              {showStaticUnit ? (
                                <span >
                                  {totalIfAdditionNotPresent["rl"][0]?.stock}{" "}
                                  <sub>({"PRS-PAIRS"})</sub>
                                </span>
                              ) : (
                                <span>
                                  {totalIfAdditionNotPresent["rl"][0]?.stock}{" "}
                                  <sub>({totalIfAdditionNotPresent["rl"][0]?.unit})</sub>
                                </span>
                              )}

                            </td>
                            <td style={{width:"max-content"}}>
                              <strong>R:</strong>


                              {showStaticUnit ? (
                                <span >
                                  {totalIfAdditionNotPresent["r"][0]?.stock}{" "}
                                  <sub>({"PCS-PIECES"})</sub>
                                </span>
                              ) : (
                                <span>
                                  {totalIfAdditionNotPresent["r"][0]?.stock}{" "}
                                  <sub>({totalIfAdditionNotPresent["r"][0]?.unit})</sub>
                                </span>
                              )}

                            </td>
                            <td style={{width:"max-content"}}>
                              <strong>L:</strong>

                              {showStaticUnit ? (
                                <span >
                                  {totalIfAdditionNotPresent["l"][0]?.stock}{" "}
                                  <sub>({"PCS-PIECES"})</sub>
                                </span>
                              ) : (
                                <span>
                                  {totalIfAdditionNotPresent["l"][0]?.stock}{" "}
                                  <sub>({totalIfAdditionNotPresent["l"][0]?.unit})</sub>
                                </span>
                              )}


                            </td>

                          </>

                        </div>
                      ) : (
                        totalIfAdditionNotPresent
                      )}
                    </td>


                  </tr>
                </tbody>

              </table>

            </div>
          </>)
        }


        <div
          style={{
            backgroundColor: "#E1EFFD",
            justifyContent: "end",
            marginTop: "5px",
            padding: "10px 0px",
            borderRadius: "4px",
          }}
          className="flex"
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "25%",
            }}
          >
            <button onClick={handlePrevClick} class="table-list-button">
              <i class="fa-solid fa-chevron-left"></i>
            </button>
            <span class="table-list-page-txt">
              Page -{" "}
              <strong style={{ margin: "0px 3px;" }}>
                {page} of {Math.ceil(totalRecords / pageSize)}
              </strong>
            </span>
            <button onClick={handleNextClick} class="table-list-button">
              <i class="fa-solid fa-chevron-right"></i>
            </button>
          </div>
        </div>






        {/* prev start */}

        {false && lensStockReportCol.length > 0 && (
          <>
            <div className="mt-3 lens-stock-table-container" id="LensTable">
              <table className="lens-stock-table">
                <thead style={{ height: "40px" }}>
                  <tr>
                    {/* <th
                      style={{
                        position: "sticky",
                        left: "0px",
                        zIndex: 4,
                        width: "50px"
                      }}
                      className="lens-stock-table-th">S.No.</th> */}

                    {lensStockReportCol.map((collapseToast, index) => (
                      <th
                        style={
                          collapseToast.name == "Lens_SPH" ||
                            collapseToast.name == "Lens_CYL" ||
                            collapseToast.name == "Lens_EYE" ||
                            collapseToast.name == "Axis"
                            ? {
                              position: "sticky",
                              left: `${(index + 0) * 50}px`,
                              top: "-2px",
                              zIndex: 6,
                              minWidth: "50px",
                              maxWidth: "50px",
                            }
                            : {
                              position: "sticky",
                              top: "-2px",
                              zIndex: 5,
                            }
                        }
                        key={index}
                        className="lens-stock-table-th"
                      >
                        {" "}
                        {collapseToast.printName}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {lensStockReport.map((item, index) => (
                    <tr key={index} className="TrLensCreation">
                      {/* <td
                        style={{
                          position: "sticky",
                          left: "0px",
                          zIndex: 3,
                          width: "50px"
                        }}
                        className="firstColumnCellStyle tableData rows_indicator ButtonStick1 lens-stock-table-td">
                        {index + 1}
                      </td> */}

                      {lensStockReportCol.map((col, cIndex) => {
                        if (typeof item[col.name] == "object") {
                          return (
                            <td
                              key={`${index}-${cIndex}`}
                              style={
                                col.name == "Lens_SPH" ||
                                  col.name == "Lens_CYL" ||
                                  col.name == "Lens_EYE" ||
                                  col.name == "Axis"
                                  ? {
                                    position: "sticky",
                                    left: `${(cIndex + 0) * 50}px`,
                                    zIndex: 4,
                                    minWidth: "50px",
                                    maxWidth: "50px",
                                  }
                                  : {
                                    position: "sticky",
                                    zIndex: 3,
                                  }
                              }
                              className={`firstColumnCellStyle tableData rows_indicator ButtonStick1 lens-stock-table-td ${col.name == "Lens_SPH" ||
                                col.name == "Lens_CYL" ||
                                col.name == "Lens_EYE" ||
                                col.name == "Axis"
                                ? "lens-stock-table-td-color"
                                : ""
                                }`}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >

                                {item[`${col.name}_isDeleted`] ? '-' : (

                                  <>

                                    <td>
                                      <strong>RL:</strong>
                                      {item[col.name]["rl"] &&
                                        item[col.name]["rl"].map(
                                          (stock, sIndex) => {
                                            if (sIndex == 0) {
                                              if (showStaticUnit) {
                                                return (
                                                  <span key={sIndex}>
                                                    {stock.stock}{" "}
                                                    <sub>({"PRS-PAIRS"})</sub>
                                                  </span>
                                                );
                                              } else {
                                                return (
                                                  <span key={sIndex}>
                                                    {stock.stock}{" "}
                                                    <sub>({stock.unit})</sub>
                                                  </span>
                                                );
                                              }
                                            } else {
                                              if (showStaticUnit) {
                                                return (
                                                  <span key={sIndex}>
                                                    {stock.stock}{" "}
                                                    <sub>({"PRS-PAIRS"})</sub>
                                                  </span>
                                                );
                                              } else {
                                                return (
                                                  <span key={sIndex}>
                                                    {stock.stock}{" "}
                                                    <sub>({stock.unit})</sub>
                                                  </span>
                                                );
                                              }
                                            }
                                          }
                                        )}
                                    </td>
                                    <td>
                                      <strong>R:</strong>
                                      {item[col.name]["r"] &&
                                        item[col.name]["r"].map((stock, sIndex) => {
                                          if (sIndex == 0) {
                                            if (showStaticUnit) {
                                              return (
                                                <span key={sIndex}>
                                                  {stock.stock}{" "}
                                                  <sub>({"PCS-PIECES"})</sub>
                                                </span>
                                              );
                                            } else {
                                              return (
                                                <span key={sIndex}>
                                                  {stock.stock}{" "}
                                                  <sub>({stock.unit})</sub>
                                                </span>
                                              );
                                            }
                                          } else {
                                            if (showStaticUnit) {
                                              return (
                                                <span key={sIndex}>
                                                  {stock.stock}{" "}
                                                  <sub>({"PCS-PIECES"})</sub>
                                                </span>
                                              );
                                            } else {
                                              return (
                                                <span key={sIndex}>
                                                  {stock.stock}{" "}
                                                  <sub>({stock.unit})</sub>
                                                </span>
                                              );
                                            }
                                          }
                                        })}
                                    </td>
                                    <td>
                                      <strong>L:</strong>
                                      {item[col.name]["l"] &&
                                        item[col.name]["l"].map((stock, sIndex) => {
                                          if (sIndex == 0) {
                                            if (showStaticUnit) {
                                              return (
                                                <span key={sIndex}>
                                                  {stock.stock}{" "}
                                                  <sub>({"PCS-PIECES"})</sub>
                                                </span>
                                              );
                                            } else {
                                              return (
                                                <span key={sIndex}>
                                                  {stock.stock}{" "}
                                                  <sub>({stock.unit})</sub>
                                                </span>
                                              );
                                            }
                                          } else {
                                            if (showStaticUnit) {
                                              return (
                                                <span key={sIndex}>
                                                  {stock.stock}{" "}
                                                  <sub>({"PCS-PIECES"})</sub>
                                                </span>
                                              );
                                            } else {
                                              return (
                                                <span key={sIndex}>
                                                  {stock.stock}{" "}
                                                  <sub>({stock.unit})</sub>
                                                </span>
                                              );
                                            }
                                          }
                                        })}
                                    </td>

                                  </>
                                )}



                              </div>
                            </td>
                          );
                        } else {
                          return (
                            <td
                              key={`${index}-${cIndex}`}
                              style={
                                col.name == "Lens_SPH" ||
                                  col.name == "Lens_CYL" ||
                                  col.name == "Lens_EYE" ||
                                  col.name == "Axis"
                                  ? {
                                    position: "sticky",
                                    left: `${(cIndex + 0) * 50}px`,
                                    zIndex: 4,
                                    minWidth: "50px",
                                    maxWidth: "50px",
                                  }
                                  : {
                                    position: "sticky",
                                    zIndex: 3,
                                  }
                              }
                              className={`firstColumnCellStyle tableData rows_indicator ButtonStick1 lens-stock-table-td ${col.name == "Lens_SPH" ||
                                col.name == "Lens_CYL" ||
                                col.name == "Lens_EYE" ||
                                col.name == "Axis"
                                ? "lens-stock-table-td-color"
                                : ""
                                }`}
                            >
                              {item[`${col.name}_isDeleted`] ? '-' : item[col.name]}
                            </td>
                          );
                        }
                      })}
                    </tr>
                  ))}

                  <tr className="TrLensCreation">
                    {/* <td
                      style={{
                        position: "sticky",
                        left: "0px",
                        zIndex: 3,
                        width: "50px"
                      }}
                      className="firstColumnCellStyle tableData rows_indicator ButtonStick1 lens-stock-table-td">

                    </td> */}

                    <td
                      colSpan={numberOfFirstNotAddColumns}
                      style={{
                        position: "sticky",
                        left: `${0 * 100}px`,
                        zIndex: 5,
                        minWidth: "100px",
                      }}
                      className="firstColumnCellStyle tableData rows_indicator ButtonStick1 lens-stock-table-td lens-stock-table-td-color"
                    >
                      Total
                    </td>

                    {lensStockReportCol.map((col, cIndex) => {
                      if (col.name.startsWith("Add")) {
                        if (
                          typeof lensStockReportColWiseTotal[col.name] ==
                          "object"
                        ) {
                          return (
                            <td
                              key={`${cIndex}`}
                              className="firstColumnCellStyle tableData rows_indicator ButtonStick1 lens-stock-table-td"
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <td>
                                  <strong>RL:</strong>{" "}
                                  {lensStockReportColWiseTotal[col.name][
                                    "rl"
                                  ].map((stock, sIndex) => {
                                    if (sIndex == 0) {
                                      if (showStaticUnit) {
                                        return (
                                          <span key={sIndex}>
                                            {stock.stock}{" "}
                                            <sub>({"PRS-PAIRS"})</sub>
                                          </span>
                                        );
                                      } else {
                                        return (
                                          <span key={sIndex}>
                                            {stock.stock}{" "}
                                            <sub>({stock.unit})</sub>
                                          </span>
                                        );
                                      }
                                    } else {
                                      if (showStaticUnit) {
                                        return (
                                          <span key={sIndex}>
                                            {stock.stock}{" "}
                                            <sub>({"PRS-PAIRS"})</sub>
                                          </span>
                                        );
                                      } else {
                                        return (
                                          <span key={sIndex}>
                                            {stock.stock}{" "}
                                            <sub>({stock.unit})</sub>
                                          </span>
                                        );
                                      }
                                    }
                                  })}
                                </td>
                                <td>
                                  <strong>R:</strong>{" "}
                                  {lensStockReportColWiseTotal[col.name][
                                    "r"
                                  ].map((stock, sIndex) => {
                                    if (sIndex == 0) {
                                      if (showStaticUnit) {
                                        return (
                                          <span key={sIndex}>
                                            {stock.stock}{" "}
                                            <sub>({"PCS-PIECES"})</sub>
                                          </span>
                                        );
                                      } else {
                                        return (
                                          <span key={sIndex}>
                                            {stock.stock}{" "}
                                            <sub>({stock.unit})</sub>
                                          </span>
                                        );
                                      }
                                    } else {
                                      if (showStaticUnit) {
                                        return (
                                          <span key={sIndex}>
                                            {stock.stock}{" "}
                                            <sub>({"PCS-PIECES"})</sub>
                                          </span>
                                        );
                                      } else {
                                        return (
                                          <span key={sIndex}>
                                            {stock.stock}{" "}
                                            <sub>({stock.unit})</sub>
                                          </span>
                                        );
                                      }
                                    }
                                  })}
                                </td>
                                <td>
                                  <strong>L:</strong>{" "}
                                  {lensStockReportColWiseTotal[col.name][
                                    "l"
                                  ].map((stock, sIndex) => {
                                    if (sIndex == 0) {
                                      if (showStaticUnit) {
                                        return (
                                          <span key={sIndex}>
                                            {stock.stock}{" "}
                                            <sub>({"PCS-PIECES"})</sub>
                                          </span>
                                        );
                                      } else {
                                        return (
                                          <span key={sIndex}>
                                            {stock.stock}{" "}
                                            <sub>({stock.unit})</sub>
                                          </span>
                                        );
                                      }
                                    } else {
                                      if (showStaticUnit) {
                                        return (
                                          <span key={sIndex}>
                                            {stock.stock}{" "}
                                            <sub>({"PCS-PIECES"})</sub>
                                          </span>
                                        );
                                      } else {
                                        return (
                                          <span key={sIndex}>
                                            {stock.stock}{" "}
                                            <sub>({stock.unit})</sub>
                                          </span>
                                        );
                                      }
                                    }
                                  })}
                                </td>
                              </div>
                            </td>
                          );
                        } else {
                          return (
                            <td
                              key={`${cIndex}`}
                              className="firstColumnCellStyle tableData rows_indicator ButtonStick1 lens-stock-table-td"
                            >
                              {lensStockReportColWiseTotal[col.name]}
                            </td>
                          );
                        }
                      }
                    })}

                    {typeof wholeTotal == "object" ? (
                      <td className="firstColumnCellStyle tableData rows_indicator ButtonStick1 lens-stock-table-td">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <td>
                            <strong>RL:</strong>{" "}
                            {wholeTotal["rl"].map((stock, sIndex) => {
                              if (sIndex == 0) {
                                if (showStaticUnit) {
                                  return (
                                    <span key={sIndex}>
                                      {stock.stock} <sub>({"PRS-PAIRS"})</sub>
                                    </span>
                                  );
                                } else {
                                  return (
                                    <span key={sIndex}>
                                      {stock.stock} <sub>({stock.unit})</sub>
                                    </span>
                                  );
                                }
                              } else {
                                if (showStaticUnit) {
                                  return (
                                    <span key={sIndex}>
                                      {stock.stock} <sub>({"PRS-PAIRS"})</sub>
                                    </span>
                                  );
                                } else {
                                  return (
                                    <span key={sIndex}>
                                      {stock.stock} <sub>({stock.unit})</sub>
                                    </span>
                                  );
                                }
                              }
                            })}
                          </td>
                          <td>
                            <strong>R:</strong>{" "}
                            {wholeTotal["r"].map((stock, sIndex) => {
                              if (sIndex == 0) {
                                if (showStaticUnit) {
                                  return (
                                    <span key={sIndex}>
                                      {stock.stock} <sub>({"PCS-PIECES"})</sub>
                                    </span>
                                  );
                                } else {
                                  return (
                                    <span key={sIndex}>
                                      {stock.stock} <sub>({stock.unit})</sub>
                                    </span>
                                  );
                                }
                              } else {
                                if (showStaticUnit) {
                                  return (
                                    <span key={sIndex}>
                                      {stock.stock} <sub>({"PCS-PIECES"})</sub>
                                    </span>
                                  );
                                } else {
                                  return (
                                    <span key={sIndex}>
                                      {stock.stock} <sub>({stock.unit})</sub>
                                    </span>
                                  );
                                }
                              }
                            })}
                          </td>
                          <td>
                            <strong>L:</strong>{" "}
                            {wholeTotal["l"].map((stock, sIndex) => {
                              if (sIndex == 0) {
                                if (showStaticUnit) {
                                  return (
                                    <span key={sIndex}>
                                      {stock.stock} <sub>({"PCS-PIECES"})</sub>
                                    </span>
                                  );
                                } else {
                                  return (
                                    <span key={sIndex}>
                                      {stock.stock} <sub>({stock.unit})</sub>
                                    </span>
                                  );
                                }
                              } else {
                                if (showStaticUnit) {
                                  return (
                                    <span key={sIndex}>
                                      {stock.stock} <sub>({"PCS-PIECES"})</sub>
                                    </span>
                                  );
                                } else {
                                  return (
                                    <span key={sIndex}>
                                      {stock.stock} <sub>({stock.unit})</sub>
                                    </span>
                                  );
                                }
                              }
                            })}
                          </td>
                        </div>
                      </td>
                    ) : (
                      <td className="firstColumnCellStyle tableData rows_indicator ButtonStick1 lens-stock-table-td">
                        {wholeTotal}
                      </td>
                    )}
                    {/* <td className="firstColumnCellStyle tableData rows_indicator ButtonStick1 lens-stock-table-td">
                      {typeof wholeTotal == "object" ? `${wholeTotal.rl} \n ${wholeTotal.r} \n ${wholeTotal.l}` : wholeTotal}
                    </td> */}
                  </tr>
                </tbody>
              </table>
            </div>

            <div
              style={{
                backgroundColor: "#E1EFFD",
                justifyContent: "end",
                marginTop: "5px",
                padding: "10px 0px",
                borderRadius: "4px",
              }}
              className="flex"
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "25%",
                }}
              >
                <button onClick={handlePrevClick} class="table-list-button">
                  <i class="fa-solid fa-chevron-left"></i>
                </button>
                <span class="table-list-page-txt">
                  Page -{" "}
                  <strong style={{ margin: "0px 3px;" }}>
                    {page} of {Math.ceil(totalRecords / pageSize)}
                  </strong>
                </span>
                <button onClick={handleNextClick} class="table-list-button">
                  <i class="fa-solid fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </>
        )}
      </div>

      {alertBox && (
        <AlertBox
          HeadingTop="Saved"
          Heading="Your Item Master is Saved"
          onYesClick={OpenAlertBox}
          singleButton={true}
          OpenAlertBox={OpenAlertBox}
        />
      )}

      {alertBoxEdit && (
        <AlertBox
          HeadingTop="Updated"
          Heading="Your Item Master is Updated"
          onYesClick={OpenAlertBoxEdit}
          singleButton={true}
          OpenAlertBox={OpenAlertBoxEdit}
        />
      )}

      {alertBoxErrorInsert && (
        <AlertBoxError
          HeadingTop="ERROR"
          Heading="Error While inserting Data"
          onYesClick={OpenAlertBoxErrorInsert}
          singleButton={true}
          OpenAlertBox={OpenAlertBoxErrorInsert}
        />
      )}

      {alertBoxErrorUpdate && (
        <AlertBoxError
          HeadingTop="ERROR"
          Heading="Error While Updating Data"
          onYesClick={OpenAlertBoxErrorUpdate}
          singleButton={true}
          OpenAlertBox={OpenAlertBoxErrorUpdate}
        />
      )}
      {loading && <Loader />}
      {isModalOpen2 && (
        <div className="modal-back">
          <div
            className="partyDetail-modal"
            style={{ height: "90%", width: "90%", backgroundColor: "white" }}
          >
            <div style={{ padding: "15px", overflowY: "auto", height: "85vh" }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <label></label>
                <label
                  style={{ cursor: "pointer", fontSize: "24px" }}
                  onClick={showModal2}
                >
                  x
                </label>
              </div>
              <ItemMaster
                // parentGrpName={parentGrpName}
                // modelOpen={modalOpen}
                modelOpen={showModal2}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LensStock;
